export default __webpack_public_path__ + "static/1844-521efad14f22b9452aca554a96ba8b69.gif";